// extracted by mini-css-extract-plugin
export default {"container":"editProfile_container__hrGEB","header":"editProfile_header__na2X-","backBtn":"editProfile_backBtn__AmD7O","footer":"editProfile_footer__nvX4L"};